import React, { useEffect, useMemo, useState } from "react";
import Hoc from "../../components/HOC";
import { useNavigate } from "react-router-dom";
import ModalComponent from "../../components/Modal";
import FileUploadComponent from "../../components/FileUploadComponent";
import {
  EditUserSchema,
  getValuesFromLocalstorage,
  UpdatePasswordSchema,
} from "../../components/Helpers";
import { useDispatch, useSelector } from "react-redux";
import {
  requestGetCoverImage,
  requestGetProfilePicture,
  requestProfileAction,
  requestUpdateProfileForUser,
  requestUploadCoverImage,
  requestUploadProfilePicture,
  setResetUpdateProfiileForUser,
  setResetUploadCoverImage,
  setResetUploadProfilePicture,
} from "../../Redux/ProfileState/ProfileActionCreator";
import Loader from "../../components/Loader";
import {
  requestUploadFileAction,
  setResetStateuploadFile,
} from "../../Redux/FileState/uploadFileActionCreator";
import { toast } from "react-toastify";
import {
  requestEdituser,
  setResetStateEditUser,
} from "../../Redux/UserState/UserActionCreator";
import { Formik, Form } from "formik";
import {
  Camera,
  Mail,
  Phone,
  Home,
  MapPin,
  Globe,
  Building,
  User,
  Edit,
  Check,
  X,
  Lock,
  Settings,
  Key,
  Eye,
  EyeOff,
  Shield,
  Calendar,
} from "lucide-react";
import TextInput from "../../components/TextInput";
import CustomDropdown from "../../components/CustomDropdown";
import LOCAL_KEYS, {
  parseLocalStorageJSON,
  setToLocalStorage,
} from "../../helpers/Localstorage";
import FormButton from "../../components/FormButton";
import {
  requestUpdatePassword,
  setResetUpdatePassword,
} from "../../Redux/LoginState/LoginActionCreator";
import Swal from "sweetalert2";
import moment from "moment";
import AlertsCard from "../../components/AlertsCard";
import { ContactInfoSchema, AddressSchema } from "../../components/Helpers";
import zipcodes from 'zipcodes';


const EmployeeProfile = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [isProfileImageModalOpen, setProfileImageModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("personal");
  const [isSubmitted, setIsSubmitted] = useState(false);

  // const userDetails = getValuesFromLocalstorage("userDetails");
  const userDetails = useMemo(
    () => getValuesFromLocalstorage("userDetails") || {},
    []
  );
  const userId = userDetails?.id || userDetails?.username;
  const ProfileReducer = useSelector((state) => state.ProfileReducer);
  const fileUploadReducer = useSelector((state) => state.UploadFileReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const editUserReducer = useSelector((state) => state.EditUserReducer);
  const updateUserReducer = useSelector(
    (state) => state.UpdateProfileUserReducer
  );
  const UpdatePasswordState = useSelector(
    (state) => state.UpdatePasswordReducer
  );
  const uploadProfilepicture = useSelector(
    (state) => state.UploadProfilePictureReducer
  );
  const getProfileImageReducer = useSelector(
    (state) => state.GetProfilePictureReducer
  );
  const uploadCoverImage = useSelector(
    (state) => state.UploadCoverImageReducer
  );

  const getCoverImageReducer = useSelector(
    (state) => state.GetCoverImageReducer
  );
  const [profile, setProfile] = useState(userDetails || {});
  const [profileImage, setProfileImage] = useState("/default-cover.jpg");
  const [imageError, setImageError] = useState(false);
  const [coverImage, setCoverImage] = useState("/default-cover.jpg");
  // Password visibility states
  const [oldPasswordVisible, setOldPasswordVisible] = useState(false);
  const [newPasswordVisible, setNewPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  // Password strength
  const [passwordStrength, setPasswordStrength] = useState(0);
  const [missingCriteria, setMissingCriteria] = useState([]);

  const countryOptions = [
    { value: "USA", label: "USA" },
    { value: "IN", label: "IN" },
  ];

  // Password strength checking
  const checkPasswordStrength = (password) => {
    const criteria = [
      { test: (pw) => /[a-z]/.test(pw), message: "Lowercase letter" },
      { test: (pw) => /[A-Z]/.test(pw), message: "Uppercase letter" },
      { test: (pw) => /\d/.test(pw), message: "Number" },
      {
        test: (pw) => /[@$!%*?&#]/.test(pw),
        message: "Special character",
      },
      { test: (pw) => pw.length >= 8, message: "8+ characters" },
    ];

    const unmetCriteria = criteria
      .filter((criterion) => !criterion.test(password))
      .map((criterion) => criterion.message);

    setMissingCriteria(unmetCriteria);
    setPasswordStrength(criteria.length - unmetCriteria.length);
  };

  const getStrengthColor = () => {
    if (passwordStrength <= 2) return "bg-red-500";
    if (passwordStrength <= 3) return "bg-amber-500";
    return "bg-green-500";
  };

  const getStrengthText = () => {
    if (passwordStrength <= 2) return "Weak";
    if (passwordStrength <= 3) return "Medium";
    return "Strong";
  };

  // const resetPassword = (values) => {
  //   dispatch(requestUpdatePassword(values));
  // };

  const uploadDocumentFuction = () => {
    handleDrawerOpen();
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleEditToggle = () => {
    setIsEditing(!isEditing);
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  const openProfileImageModal = () => {
    setProfileImageModalOpen(true);
  };

  const closeProfileImageModal = () => {
    setProfileImageModalOpen(false);
  };

  const fileSave = (file) => {
    dispatch(requestUploadFileAction({ file: file, isCoverImage: true }));
  };

  const profileImageSave = (file) => {
    if (!file) {
      toast.error("No file selected for upload");
      return;
    }

    // Validate file type and size
    const allowedTypes = ["image/jpeg", "image/png", "image/gif"];
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (!allowedTypes.includes(file.type)) {
      toast.error("Only JPEG, PNG, or GIF files are allowed");
      return;
    }
    if (file.size > maxSize) {
      toast.error("File size must be less than 5MB");
      return;
    }

    // Create metadata payload
    const metadata = {
      userId: userDetails?.id || userDetails?.username, // Adjust based on userDetails
    };

    const formData = new FormData();
    formData.append("metadata", JSON.stringify(metadata));
    formData.append("image", file); // Try 'image' if 'files' fails

    dispatch(requestUploadProfilePicture(formData));
  };

  useEffect(() => {
    if (userId) {
      dispatch(requestGetCoverImage(userId)); // Fetch cover image for the logged-in user
    } else {
      setImageError(true); // Handle the error gracefully
    }
  }, [userId]);

  useEffect(() => {
    if (
      userId &&
      !getProfileImageReducer?.loading &&
      !getProfileImageReducer?.error
    ) {
      dispatch(requestGetProfilePicture(userId));
    } else if (!userId) {
      setImageError(true); // Handle the error gracefully
    } else if (getProfileImageReducer?.error?.status === 403) {
      setImageError(true); // Handle the error gracefully
    }
  }, [userId]);

  const coverImageSave = (file) => {
    if (!file) {
      toast.error("No file selected for upload");
      return;
    }

    // Validate file type and size
    const allowedTypes = ["image/jpeg", "image/png", "image/gif"];
    const maxSize = 5 * 1024 * 1024; // 5MB
    const minSize = 10 * 1024; // 10KB
    
    if (!allowedTypes.includes(file.type)) {
      toast.error("Only JPEG, PNG, or GIF files are allowed");
      return;
    }
    if (file.size > maxSize) {
      toast.error("File size must be less than 5MB");
      return;
    }
    if (file.size < minSize) {
      toast.error("File size must be at least 10KB");
      return;
    }

    // Create metadata payload
    const metadata = {
      userId: userDetails?.id || userDetails?.username, // Adjust based on userDetails
    };

    const formData = new FormData();
    formData.append("metadata", JSON.stringify(metadata));
    formData.append("file", file); // Try 'image' if 'files' fails

    dispatch(requestUploadCoverImage(formData)); // Dispatch the Redux action
  };
  useEffect(() => {
    if (userId) {
      dispatch(requestGetCoverImage(userId)); // Fetch cover image for the logged-in user
    } else {
      setImageError(true); // Handle the error gracefully
    }
  }, [userId]);

  useEffect(() => {
    if (
      getProfileImageReducer?.response &&
      getProfileImageReducer?.response?.blobUrl &&
      !getProfileImageReducer?.loading &&
      !getProfileImageReducer?.error
    ) {
      dispatch(requestGetProfilePicture(userId));
    } else if (!userId) {
      setImageError(true); // Handle the error gracefully
    } else if (getProfileImageReducer?.error?.status === 403) {
      setImageError(true); // Handle the error gracefully
    }
  }, [userId]);

  useEffect(() => {
    if (!uploadCoverImage?.loading && uploadCoverImage?.response) {
      const imgUrl =
        uploadCoverImage?.response?.url || uploadCoverImage?.response;

      if (typeof imgUrl === "string" && imgUrl.startsWith("data:image/")) {
        setCoverImage(imgUrl);
        setImageError(false);

        // Update localStorage
        const updatedUserDetails = {
          ...userDetails,
          coverImage: imgUrl,
        };
        setToLocalStorage(LOCAL_KEYS.USER_DETAILS, updatedUserDetails);

        // Update profile state
        setProfile((prev) => ({
          ...prev,
          coverImage: imgUrl,
        }));

        toast.success("Cover Image Uploaded Successfully");
        dispatch(requestGetCoverImage(userId));
      } else {
        setImageError(true);
        toast.error("Invalid image URL received");
      }

      handleDrawerClose(); // Close the modal
      dispatch(setResetUploadCoverImage());
    } else if (!uploadCoverImage?.loading && uploadCoverImage?.error) {
      toast.error(
        uploadCoverImage?.error?.message || "Failed to upload cover image"
      );
      setImageError(true);
      handleDrawerClose(); // Close the modal
      dispatch(setResetUploadCoverImage());
    }
  }, [uploadCoverImage, userDetails]);
  useEffect(() => {
    if (!uploadProfilepicture?.loading && uploadProfilepicture?.response) {
      const imgUrl =
        uploadProfilepicture?.response?.url || uploadProfilepicture?.response;

      if (typeof imgUrl === "string" && imgUrl.startsWith("data:image/")) {
        setProfileImage(imgUrl);
        setImageError(false);

        // Update localStorage
        const updatedUserDetails = {
          ...userDetails,
          profileImage: imgUrl,
        };
        setToLocalStorage(LOCAL_KEYS.USER_DETAILS, updatedUserDetails);

        // Update profile state
        setProfile((prev) => ({
          ...prev,
          profileImage: imgUrl,
        }));

        toast.success("Picture Uploaded Successfully");
        dispatch(requestGetProfilePicture(userId));
      } else {
        setImageError(true);
        toast.error("Invalid image URL received");
      }

      closeProfileImageModal(); // Close the modal for cover image
      dispatch(setResetUploadProfilePicture());
    } else if (!uploadProfilepicture?.loading && uploadProfilepicture?.error) {
      toast.error(
        uploadProfilepicture?.error?.message ||
          "Failed to upload profile picture"
      );
      setImageError(true);
      closeProfileImageModal(); // Close the modal for cover image
      dispatch(setResetUploadProfilePicture());
    }
  }, [uploadProfilepicture, userDetails]);

  // Token validation
  useEffect(() => {
    const token = parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN);
    if (!token) {
      toast.error("Session expired. Please log in again.");
      navigate("/login");
    }
  }, [navigate]);

  useEffect(() => {
    return () => {
      // Reset state on component unmount or logout
      setProfileImage(null);
      setImageError(false);
    };
  }, []);
  useEffect(() => {
    return () => {
      setCoverImage(null); // Reset to default cover image
      setImageError(false);
    };
  }, []);
  useEffect(() => {
    return () => {
      const storedUserDetails = parseLocalStorageJSON(LOCAL_KEYS.USER_DETAILS);
      if (storedUserDetails) {
        setToLocalStorage(LOCAL_KEYS.USER_DETAILS, {
          ...storedUserDetails,
          profileImage: null,
        });
      }
      setProfileImage(null);
      setImageError(false);
    };
  }, []);

  const resetPassword = (values) => {
    dispatch(requestUpdatePassword(values));
  };
  // useEffect(() => {
  //   if (updateUserReducer?.response) {
  //     // Ensure we preserve the profile image when updating other profile details
  //     const updatedProfile = {
  //       ...updateUserReducer.response,
  //       profileImage: profileImage || userDetails?.profileImage,
  //       coverImage: coverImage || userDetails?.coverImage,
  //     };
  //     setToLocalStorage(LOCAL_KEYS.USER_DETAILS, updatedProfile);
  //     setIsEditing(false);
  //     toast.success("Profile Updated Successfully");
  //     dispatch(setResetUpdateProfiileForUser());
  //   }
  // }, [updateUserReducer]);
  useEffect(() => {
    if (ProfileReducer?.response) {
      setProfile(ProfileReducer?.response);
    }
  }, [ProfileReducer]);

  useEffect(() => {
    if (updateUserReducer?.response) {
      // Update localStorage with new values
      setToLocalStorage(LOCAL_KEYS.USER_DETAILS, updateUserReducer.response);
      
      // Update both profile and userDetails states
      setProfile(updateUserReducer.response);
      const updatedUserDetails = {
        ...userDetails,
        ...updateUserReducer.response
      };
      setToLocalStorage(LOCAL_KEYS.USER_DETAILS, updatedUserDetails);
      
      dispatch(setResetUpdateProfiileForUser());
      setIsEditing(false);
      toast.success("Profile Updated Successfully");
    }
  }, [updateUserReducer]);

  useEffect(() => {
    if (
      UpdatePasswordState?.updateResponse &&
      !UpdatePasswordState?.updateLoading
    ) {
      // setIsSubmitted(true);
      toast.success("Password updated successfully");

      dispatch(setResetUpdatePassword());
    }

    if (
      UpdatePasswordState?.updateError &&
      !UpdatePasswordState?.updateLoading
    ) {
      const errorMessage = UpdatePasswordState?.updateError?.message.message;
      if (errorMessage) {
        Swal.fire({
          title: errorMessage,
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ok",
          backdrop: `rgba(0, 0, 0, 0.5)`,
        }).then((result) => {
          if (result.isConfirmed) {
            dispatch(setResetUpdatePassword());
          }
        });
      } else {
        toast.error("Unable to update password");
        dispatch(setResetUpdatePassword());
      }
    }
  }, [UpdatePasswordState]);

  useEffect(() => {
    return () => {
      dispatch(setResetUpdateProfiileForUser());
      dispatch(setResetStateuploadFile());
      dispatch(setResetUpdatePassword());
      dispatch(setResetUploadProfilePicture());
      dispatch(requestGetProfilePicture());
      dispatch(setResetUploadCoverImage());
      dispatch(requestGetCoverImage());
    };
  }, []);

  useEffect(() => {
    if (updateUserReducer?.error) {
      toast.error(updateUserReducer.error.message || "Failed to update profile");
      dispatch(setResetUpdateProfiileForUser());
    }
  }, [updateUserReducer?.error]);

  return (
    <div className="w-full h-[96vh] sm:h-[85vh] md:h-[92vh] lg:h-[96vh] overflow-y-auto px-5 py-3"> 
      <AlertsCard />
      {/* <Loader isLoading={
        ProfileReducer.loading || updateUserReducer.loading || fileUploadReducer.Loading || UpdatePasswordState?.updateLoading|| 
        getProfileImageReducer.loading || uploadProfilepicture.loading
      } /> */}

      {/* Modals */}
      <ModalComponent
        show={isDrawerOpen}
        onClose={handleDrawerClose}
        title="Upload Cover Image"
      >
        <FileUploadComponent
          accept={[".jpg", ".jpeg", ".png"]}
          fileSave={coverImageSave}
        />
      </ModalComponent>

      <ModalComponent
        show={isProfileImageModalOpen}
        onClose={closeProfileImageModal}
        title="Update Profile Picture"
      >
        <FileUploadComponent
          accept={[".jpg", ".jpeg", ".png"]}
          fileSave={profileImageSave}
        />
      </ModalComponent>

      {/* Profile Header with Cover Image */}
      <div className="relative mb-28 sm:mb-24">
        <div className="h-64 w-full bg-gradient-to-r from-indigo-600 via-purple-600 to-blue-600 relative overflow-hidden rounded-lg">
          {/* {coverImage && ( */}
          <img
            src={getCoverImageReducer.response || coverImage} // Use the updated Base64 string
            alt="Cover"
            className="w-full h-full object-cover"
            onError={() => setCoverImage(true)}
          />
          {/* )} */}
          {/* {userDetails?.acctType === "ADMIN" && ( */}
          <button
            onClick={handleDrawerOpen}
            className="absolute bottom-4 right-4 bg-white/80 hover:bg-white text-gray-800 p-2 rounded-full shadow-lg transition-all duration-300 z-10"
            title="Change Cover Image"
          >
            <Camera size={20} />
          </button>
          {/* // )} */}
        </div>

        {/* Profile Picture */}
        <div className="absolute left-1/2 transform -translate-x-1/2 -bottom-20 sm:-bottom-16">
          <div
            className="w-40 h-40 sm:w-32 sm:h-32 rounded-full border-4 border-white bg-white shadow-xl flex items-center justify-center text-gray-700 text-5xl font-bold relative overflow-hidden cursor-pointer group"
            onClick={openProfileImageModal}
          >
            <img
              src={getProfileImageReducer.response || profileImage} // Use the updated Base64 string
              alt="Profile"
              className="w-full h-full object-cover"
              onError={() => setImageError(true)} // Handle image load errors
            />
            <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 flex items-center justify-center transition-all duration-300">
              <div className="text-white opacity-0 group-hover:opacity-100 transition-all duration-300">
                <Camera size={32} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Profile Info */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
        {/* User Name and Type */}
        <div className="text-center mb-8">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-800">
            {profile?.firstName} {profile?.lastName}
          </h1>
          <p className="text-gray-500 mt-1">
            {profile?.acctType === "ADMIN" ? "Administrator" : "Employee"}
          </p>
        </div>

        {/* Content Container */}
        <div className="bg-white rounded-xl shadow-sm overflow-hidden relative">
          {/* Edit/Save Buttons - Positioned to the top right */}
          <div className="flex justify-end p-4 border-b border-gray-100 h-[60px]">
          {activeTab !== "personal" && !isEditing && (
              <FormButton
                onClick={handleEditToggle}
                icon={<Edit size={18} className="ml-1 " />}
                title="Edit Profile"
                size="sm"
                // variant="outline"
                 className="h-10"
              />
            )}
          </div>
 
          {/* Tabs Navigation */}
          <div className="border-b border-gray-200 px-4">
            <nav className="flex -mb-px space-x-8 overflow-x-auto scrollbar-hide">
              <div className="flex space-x-8 min-w-max">
                <button
                  onClick={() => setActiveTab("personal")}
                  className={`py-4 px-1 font-medium text-sm border-b-2 whitespace-nowrap ${
                    activeTab === "personal"
                      ? "border-indigo-500 text-indigo-600"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  } flex items-center transition-colors`}
                >
                  <User size={16} className="mr-2" />
                  Personal
                </button>
                <button
                  onClick={() => setActiveTab("contact")}
                  className={`py-4 px-1 font-medium text-sm border-b-2 whitespace-nowrap ${
                    activeTab === "contact"
                      ? "border-indigo-500 text-indigo-600"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  } flex items-center transition-colors`}
                >
                  <Mail size={16} className="mr-2" />
                  Contact
                </button>
                <button
                  onClick={() => setActiveTab("address")}
                  className={`py-4 px-1 font-medium text-sm border-b-2 whitespace-nowrap ${
                    activeTab === "address"
                      ? "border-indigo-500 text-indigo-600"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  } flex items-center transition-colors`}
                >
                  <MapPin size={16} className="mr-2" />
                  Address
                </button>
                <button
                  onClick={() => setActiveTab("security")}
                  className={`py-4 px-1 font-medium text-sm border-b-2 whitespace-nowrap ${
                    activeTab === "security"
                      ? "border-indigo-500 text-indigo-600"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  } flex items-center transition-colors`}
                >
                  <Lock size={16} className="mr-2" />
                  Security
                </button>
              </div>
            </nav>
          </div>

          {/* Tab Content */}
          <Formik
            initialValues={profile || {}}
            enableReinitialize
            onSubmit={(values) => {
              dispatch(requestUpdateProfileForUser({ user: values }));
              setIsEditing(false);
            }}
            validationSchema={EditUserSchema}
          >
            {({
              handleChange,
              values,
              setFieldValue,
              errors,
              touched,
              handleSubmit,
              resetForm,
            }) => (
              <Form id="profileForm">
                <div className="p-6">
                  {activeTab === "personal" && (
                    <Formik
                      initialValues={profile || {}}
                      // validationSchema={PersonalInfoSchema}
                      onSubmit={(values) => {
                        dispatch(requestUpdateProfileForUser({ user: values }));
                        setIsEditing(false);
                      }}
                      enableReinitialize
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleSubmit,
                      }) => (
                        <form onSubmit={handleSubmit} className="space-y-6">
                          <div className="space-y-6">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                              {/* First Name */}
                              <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                  First Name
                                </label>
                                <div className="p-3 bg-gray-50 rounded-lg border border-gray-100 flex items-center">
                                  {values.firstName}
                                </div>
                              </div>

                              {/* Last Name */}
                              <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                  Last Name
                                </label>
                                <div className="p-3 bg-gray-50 rounded-lg border border-gray-100 flex items-center">
                                  {values.lastName}
                                </div>
                              </div>

                              {/* Date of Birth */}
                              <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                  Date of Birth
                                </label>
                                <div className="p-3 bg-gray-50 rounded-lg border border-gray-100 flex items-center">

                                {values.dateOfBirth 
                                  ? moment(values.dateOfBirth).format("MM-DD-YYYY")
                                  : "Not specified"}
                              </div>
                              </div>

                              {/* Start Date */}
                              <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                  Start Date of Employment
                                </label>
                                <div className="p-3 bg-gray-50 rounded-lg border border-gray-100 flex items-center">
                                  {values.joinDate
                                    ? moment(values.joinDate, "MM-DD-YYYY").format(
                                        "MM-DD-YYYY"
                                      )
                                    : "Not specified"}
                                </div>
                              </div>
                            </div>

                            {/* Submit Button */}
                            {/* {isEditing && (
                              <div className="pt-4">
                                <button
                                  type="submit"
                                  className="bg-primary hover:bg-primaryDark text-white font-medium text-sm px-4 py-2 rounded"
                                  onClick={handleSubmit}
                                >
                                  Save Changes
                                </button>
                              </div>
                            )} */}
                          </div>
                        </form>
                      )} 
                    </Formik>
                  )}

                  {/* Contact Info Tab */}
                  {activeTab === "contact" && (
                    <Formik
                      initialValues={profile || {}}
                      validationSchema={ContactInfoSchema}
                      onSubmit={(values, { setSubmitting }) => {
                        const payload = {
                          ...values,
                          phone: values.phone || null
                        };
                        dispatch(requestUpdateProfileForUser({ user: payload }));
                        setSubmitting(false);
                      }}
                      enableReinitialize
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleSubmit,
                        isSubmitting,
                        resetForm,
                      }) => (
                        <form className="space-y-6">
                          <div className="space-y-6">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                              <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                  Email Address
                                </label>
                                <div className="p-3 bg-gray-50 rounded-lg border border-gray-100 flex items-center">
                                  <Mail size={18} className="text-gray-400 mr-2" />
                                  <p className="text-gray-900">
                                    {values.email || "Not specified"}
                                  </p>
                                </div>
                              </div>

                              <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                  Phone Number
                                </label>
                                {isEditing ? (
                                  <div>
                                    <TextInput
                                      value={values.phone || ''}
                                      name="phone"
                                      placeholder="Enter phone number"
                                      type="tel"
                                      handleChange={handleChange}
                                    />
                                    {errors.phone && touched.phone && (
                                      <div className="text-red-500 text-sm">{errors.phone}</div>
                                    )}
                                  </div>
                                ) : (
                                  <div className="p-3 bg-gray-50 rounded-lg border border-gray-100 flex items-center">
                                    <Phone size={18} className="text-gray-400 mr-2" />
                                    <p className="text-gray-900">
                                      {values.phone || "Not specified"}
                                    </p>
                                  </div>
                                )}
                              </div>
                            </div>
                            {isEditing && (
                              <div className="absolute -top-3 right-8 flex gap-3 z-10">
                                <FormButton
                                  onClick={() => {
                                    dispatch(setResetUpdateProfiileForUser());
                                    setIsEditing(false);
                                    resetForm();
                                  }}
                                  icon={<X size={18} className="ml-1 h-6" />}
                                  title="Cancel"
                                  size="sm"
                                />
                                <FormButton
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleSubmit();
                                  }}
                                  icon={<Check size={18} className="ml-1 h-6" />}
                                  title="Submit"
                                  size="sm"
                                  disabled={isSubmitting || updateUserReducer?.loading}
                                />
                              </div>
                            )}
                          </div>
                        </form>
                      )}
                    </Formik>
                  )}

                  {/* Address Tab */}
                  {activeTab === "address" && (
                    <Formik
                      initialValues={profile || {}}
                      validationSchema={AddressSchema}
                      onSubmit={(values, { setSubmitting }) => {
                        const payload = {
                          ...values,
                          addressLine1: values.addressLine1 || null,
                          city: values.city || null,
                          state: values.state || null,
                          country: values.country || null,
                          zip: values.zip || null
                        };
                        dispatch(requestUpdateProfileForUser({ user: payload }));
                        setSubmitting(false);
                      }}
                      enableReinitialize
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        resetForm,
                      }) => (
                        <form className="space-y-6">
                          <div className="space-y-6">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                              <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                  Address Line 1
                                </label>
                                {isEditing ? (
                                  <TextInput
                                    value={values.addressLine1}
                                    name="addressLine1"
                                    placeholder="Enter address line 1"
                                    handleChange={handleChange}
                                  />
                                ) : (
                                  <div className="p-3 bg-gray-50 rounded-lg border border-gray-100 flex items-center">
                                    <Home size={18} className="text-gray-400 mr-2" />
                                    <p className="text-gray-900">
                                      {values.addressLine1 || "Not specified"}
                                    </p>
                                  </div>
                                )}
                                {errors.addressLine1 && touched.addressLine1 && (
                                  <div className="text-red-500 text-sm">{errors.addressLine1}</div>
                                )}
                              </div>

                              <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                  Address Line 2
                                </label>
                                {isEditing ? (
                                  <TextInput
                                    value={values.addressLine2}
                                    name="addressLine2"
                                    placeholder="Enter address line 2"
                                    handleChange={handleChange}
                                  />
                                ) : (
                                  <div className="p-3 bg-gray-50 rounded-lg border border-gray-100 flex items-center">
                                    <Building size={18} className="text-gray-400 mr-2" />
                                    <p className="text-gray-900">
                                      {values.addressLine2 || "Not specified"}
                                    </p>
                                  </div>
                                )}
                                {errors.addressLine2 && touched.addressLine2 && (
                                  <div className="text-red-500 text-sm">{errors.addressLine2}</div>
                                )}
                              </div>

                             

                              <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                  City
                                </label>
                                {isEditing ? (
                                  <TextInput
                                    value={values.city || ''}
                                    name="city"
                                    placeholder="Enter city"
                                    handleChange={handleChange}
                                    errorMessage={touched.city && errors.city}
                                  />
                                ) : (
                                  <div className="p-3 bg-gray-50 rounded-lg border border-gray-100 flex items-center">
                                    <MapPin size={18} className="text-gray-400 mr-2" />
                                    <p className="text-gray-900">
                                      {values.city || "Not specified"}
                                    </p>
                                  </div>
                                )}
                              </div>

                              <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                  State/Province
                                </label>
                                {isEditing ? (
                                  <TextInput
                                    value={values.state || ''}
                                    name="state"
                                    placeholder="Enter state/province"
                                    handleChange={handleChange}
                                    errorMessage={touched.state && errors.state}
                                  />
                                ) : (
                                  <div className="p-3 bg-gray-50 rounded-lg border border-gray-100 flex items-center">
                                    <MapPin size={18} className="text-gray-400 mr-2" />
                                    <p className="text-gray-900">
                                      {values.state || "Not specified"}
                                    </p>
                                  </div>
                                )}
                              </div>

                              <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                  Country
                                </label>
                                {/* {isEditing ? (
                                  <TextInput
                                    value={values.country}
                                    name="country"
                                    placeholder="Enter country"
                                    handleChange={handleChange}
                                    disabled
                                  />
                                ) : (
                                  <div className="p-3 bg-gray-50 rounded-lg border border-gray-100 flex items-center">
                                    <Globe size={18} className="text-gray-400 mr-2" />
                                    <p className="text-gray-900">
                                      {countryOptions.find(
                                        (option) => option.value === values.country
                                      )?.label ||
                                        values.country ||
                                        "Not specified"}
                                    </p>
                                  </div>
                                )} */}
                                <div className="p-3 bg-gray-50 rounded-lg border border-gray-100 flex items-center">
                                  <Globe size={18} className="text-gray-400 mr-2" />
                                  <p className="text-gray-900">
                                    {values.country || "Not specified"}
                                  </p>
                                </div>
                                {errors.country && touched.country && (
                                  <div className="text-red-500 text-sm">{errors.country}</div>
                                )}
                              </div>
                              <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                  ZIP/Postal Code
                                </label>
                                {isEditing ? (
                                  <div>
                                    <TextInput
                                      value={values.zip || ''}
                                      name="zip"
                                      placeholder={values.country === 'USA' ? "Enter 5-digit ZIP code" : "Enter postal code"}
                                      handleChange={(e) => {
                                        const zipValue = e.target.value;
                                        // Only allow numbers for USA ZIP codes
                                        if (values.country === 'USA') {
                                          if (!/^\d*$/.test(zipValue)) {
                                            return; // Don't update if non-numeric
                                          }
                                          if (zipValue.length > 5) {
                                            return; // Don't allow more than 5 digits
                                          }
                                        }
                                        handleChange(e);
                                        
                                        // Only auto-fill for USA
                                        if (values.country === 'USA' && zipValue.length === 5) {
                                          const location = zipcodes.lookup(zipValue);
                                          if (location) {
                                            setFieldValue('city', location.city);
                                            setFieldValue('state', location.state);
                                          }
                                        }
                                      }}
                                    />
                                    {errors.zip && touched.zip && (
                                      <div className="text-red-500 text-sm">{errors.zip}</div>
                                    )}
                                  </div>
                                ) : (
                                  <div className="p-3 bg-gray-50 rounded-lg border border-gray-100 flex items-center">
                                    <MapPin size={18} className="text-gray-400 mr-2" />
                                    <p className="text-gray-900">
                                      {values.zip || "Not specified"}
                                    </p>
                                  </div>
                                )}
                              </div>
                            </div>
                            {isEditing && (
                              <div className="absolute -top-3 right-8 flex gap-3 z-10">
                                <FormButton
                                  onClick={() => {
                                    dispatch(setResetUpdateProfiileForUser());
                                    setIsEditing(false);
                                    resetForm();
                                  }}
                                  icon={<X size={18} className="ml-1 h-6" />}
                                  title="Cancel"
                                  size="sm"
                                />
                                <FormButton
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleSubmit();
                                  }}
                                  icon={<Check size={18} className="ml-1 h-6" />}
                                  title="Submit"
                                  size="sm"
                                  disabled={isSubmitting || updateUserReducer?.loading}
                                />
                              </div>
                            )}
                          </div>
                        </form>
                      )}
                    </Formik>
                  )}

                  {/* Security Tab - Password Management */}
                  {activeTab === "security" && (
                    <div className="space-y-6 max-w-2xl mx-auto">
                      <div className="flex items-center mb-4">
                        <Shield className="h-5 w-5 text-indigo-500 mr-2" />
                        <h2 className="text-lg font-medium text-gray-900">
                          Update Password
                        </h2>
                      </div>

                      <div className="bg-indigo-50 p-4 rounded-lg mb-6">
                        <div className="flex items-start">
                          <Key className="h-5 w-5 text-indigo-500 mt-0.5 mr-2 flex-shrink-0" />
                          <p className="text-sm text-indigo-700">
                            Your password should be at least 8 characters long
                            and include a mix of uppercase letters, lowercase
                            letters, numbers, and special characters for better
                            security.
                          </p>
                        </div>
                      </div>
                      <Loader isLoading={UpdatePasswordState.updateLoading} />
                      <Formik
                        initialValues={{
                          oldPassword: "",
                          newPassword: "",
                          confirmPassword: "",
                        }}
                        validationSchema={UpdatePasswordSchema}
                        onSubmit={(values, { resetForm }) => {
                          if (values.newPassword === values.confirmPassword) {
                            resetPassword(values);
                            resetForm();
                          } else {
                            toast.error(
                              "New password and confirm password do not match"
                            );
                          }
                        }}
                      >
                        {({
                          handleChange,
                          values,
                          errors,
                          touched,
                          handleSubmit,
                          resetForm,
                        }) => (
                          <form
                            className="space-y-5"
                            method="POST"
                            onSubmit={handleSubmit}
                          >
                            {/* Old Password Field */}
                            <div>
                              <label
                                htmlFor="oldPassword"
                                className="block text-sm font-medium text-gray-700 mb-1"
                              >
                                Current Password
                              </label>
                              {isEditing ? (
                                <div className="relative">
                                  <input
                                    type={oldPasswordVisible ? "text" : "password"}
                                    name="oldPassword"
                                    id="oldPassword"
                                    onChange={handleChange}
                                    value={values.oldPassword}
                                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                    placeholder="Enter your current password"
                                  />
                                  <button
                                    type="button"
                                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-500"
                                    onClick={() =>
                                      setOldPasswordVisible(!oldPasswordVisible)
                                    }
                                  >
                                    {oldPasswordVisible ? (
                                      <EyeOff className="h-5 w-5" />
                                    ) : (
                                      <Eye className="h-5 w-5" />
                                    )}
                                  </button>
                                </div>
                              ) : (
                                <div className="p-3 bg-gray-50 rounded-lg border border-gray-100 flex items-center">
                                  <Lock size={18} className="text-gray-400 mr-2" />
                                  {/* <p className="text-gray-900">••••••••</p> */}
                                </div>
                              )}
                              {touched.oldPassword && errors.oldPassword && (
                                <p className="mt-1 text-sm text-red-600">
                                  {errors.oldPassword}
                                </p>
                              )}
                            </div>

                            {/* New Password Field */}
                            <div>
                              <label
                                htmlFor="newPassword"
                                className="block text-sm font-medium text-gray-700 mb-1"
                              >
                                New Password
                              </label>
                              {isEditing ? (
                                <div className="relative">
                                  <input
                                    type={newPasswordVisible ? "text" : "password"}
                                    name="newPassword"
                                    id="newPassword"
                                    onChange={(e) => {
                                      handleChange(e);
                                      checkPasswordStrength(e.target.value);
                                    }}
                                    value={values.newPassword}
                                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                    placeholder="Enter new password"
                                  />
                                  <button
                                    type="button"
                                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-500"
                                    onClick={() =>
                                      setNewPasswordVisible(!newPasswordVisible)
                                    }
                                  >
                                    {newPasswordVisible ? (
                                      <EyeOff className="h-5 w-5" />
                                    ) : (
                                      <Eye className="h-5 w-5" />
                                    )}
                                  </button>
                                </div>
                              ) : (
                                <div className="p-3 bg-gray-50 rounded-lg border border-gray-100 flex items-center">
                                  <Lock size={18} className="text-gray-400 mr-2" />
                                  {/* <p className="text-gray-900">••••••••</p> */}
                                </div>
                              )}
                              {touched.newPassword && errors.newPassword && (
                                <p className="mt-1 text-sm text-red-600">
                                  {errors.newPassword}
                                </p>
                              )}

                              {/* Password Strength Indicator */}
                              {isEditing && values.newPassword && (
                                <div className="mt-3 space-y-2">
                                  <div className="flex justify-between items-center">
                                    <span className="text-sm text-gray-600">
                                      Password strength:
                                    </span>
                                    <span
                                      className={`text-sm font-medium ${
                                        passwordStrength <= 2
                                          ? "text-red-500"
                                          : passwordStrength <= 3
                                          ? "text-amber-500"
                                          : "text-green-500"
                                      }`}
                                    >
                                      {getStrengthText()}
                                    </span>
                                  </div>

                                  {/* Strength Bar */}
                                  <div className="w-full bg-gray-100 rounded-full h-1.5">
                                    <div
                                      className={`h-1.5 rounded-full ${getStrengthColor()}`}
                                      style={{
                                        width: `${
                                          (passwordStrength / 5) * 100
                                        }%`,
                                      }}
                                    ></div>
                                  </div>

                                  {/* Missing Criteria */}
                                  {missingCriteria.length > 0 && (
                                    <div className="mt-2 grid grid-cols-2 gap-2">
                                      {missingCriteria.map(
                                        (criterion, index) => (
                                          <div
                                            key={index}
                                            className="flex items-center text-xs text-gray-500"
                                          >
                                            <X
                                              size={14}
                                              className="text-red-500 mr-1 flex-shrink-0"
                                            />
                                            <span>Add {criterion}</span>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>

                            {/* Confirm Password Field */}
                            <div>
                              <label
                                htmlFor="confirmPassword"
                                className="block text-sm font-medium text-gray-700 mb-1"
                              >
                                Confirm New Password
                              </label>
                              {isEditing ? (
                                <div className="relative">
                                  <input
                                    type={confirmPasswordVisible ? "text" : "password"}
                                    name="confirmPassword"
                                    id="confirmPassword"
                                    onChange={handleChange}
                                    value={values.confirmPassword}
                                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                    placeholder="Confirm new password"
                                  />
                                  <button
                                    type="button"
                                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-500"
                                    onClick={() =>
                                      setConfirmPasswordVisible(!confirmPasswordVisible)
                                    }
                                  >
                                    {confirmPasswordVisible ? (
                                      <EyeOff className="h-5 w-5" />
                                    ) : (
                                      <Eye className="h-5 w-5" />
                                    )}
                                  </button>
                                </div>
                              ) : (
                                <div className="p-3 bg-gray-50 rounded-lg border border-gray-100 flex items-center">
                                  <Lock size={18} className="text-gray-400 mr-2" />
                                  {/* <p className="text-gray-900">••••••••</p> */}
                                </div>
                              )}
                              {touched.confirmPassword && errors.confirmPassword && (
                                <p className="mt-1 text-sm text-red-600">
                                  {errors.confirmPassword}
                                </p>
                              )}
                              {isEditing && values.newPassword && values.confirmPassword && 
                               values.newPassword !== values.confirmPassword && (
                                <p className="mt-1 text-sm text-red-600">
                                  Passwords do not match
                                </p>
                              )}
                            </div>

                            {isEditing && (
                              <div className="absolute -top-3 right-8 flex gap-3 z-10">
                                <FormButton
                                  onClick={() => {
                                    handleCancel();
                                    resetForm();
                                  }}
                                  icon={<X size={18} className="ml-1 h-6" />}
                                  title="Cancel"
                                  size="sm"
                                />
                                <FormButton
                                  onClick={handleSubmit}
                                  icon={<Check size={18} className="ml-1 h-6" />}
                                  title="Submit"
                                  size="sm"
                                />
                              </div>
                            )}
                          </form>
                        )}
                      </Formik>
                    </div>
                  )}
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default Hoc(EmployeeProfile);
